import axios from 'axios'
import { Artifact, Response, SnaphotReference } from '@/models'
import { ISearchService } from '@/services/ISearchService'
import CONSTANTS from '@/constants/Config.constants'

import { useBaseStore } from '@/stores'
import { useEnvStore } from '@/stores/envStore'

//should be refactored to use the same structur as in Rest  services
export default class SearchService implements ISearchService {
  envStore = useEnvStore()
  public async searchArtifacts(
    searchedItem: string,
    selectedSnapshotId: SnaphotReference,
    page: number,
    filter?: number,
    itemsPerPage?: number,
  ): Promise<Response<Artifact[]>> {
    const params = {
      q: searchedItem,
      page,
      pageSize: itemsPerPage ?? CONSTANTS.ARTIFACTS.SEARCH.PAGE_SIZE,
      filter,
    }

    const httpResponse = await axios.post<Response<Artifact[]>>(
      `${this.envStore.variables.ANALYZE_API_BACKEND_URL}/snapshot/${selectedSnapshotId}/search`,
      undefined,
      { params },
    )

    return httpResponse.data
  }

  async searchSnapshotArtifacts(
    searchedItem: string,
    projectId: number,
    snapshotId: number,
    page: number,
    filter?: number,
    itemsPerPage?: number,
  ): Promise<Response<Artifact[]>> {
    const pageSize: number = itemsPerPage ?? CONSTANTS.ARTIFACTS.SEARCH.PAGE_SIZE
    const baseStore = useBaseStore()
    baseStore.startNewJob()
    const params = {
      q: searchedItem,
      filter,
      page,
      pageSize,
    }

    return axios
      .post(
        `${this.envStore.variables.ANALYZE_API_BACKEND_URL}/project/${projectId}/snapshot/${snapshotId}/search`,
        undefined,
        {
          params,
          headers: {
            'Content-Type': CONSTANTS.CONTENT_TYPES.YT_V1,
            Accept: '*/*',
          },
        },
      )
      .then((response) => {
        baseStore.decrementRunningJobs()

        return response.data
      })
      .catch((error) => {
        baseStore.decrementRunningJobs()

        return Promise.reject(error)
      })
  }
}
